import { render, staticRenderFns } from "./aad-sso-callback.vue?vue&type=template&id=4cb30552&scoped=true&lang=pug&"
import script from "./aad-sso-callback.vue?vue&type=script&lang=js&"
export * from "./aad-sso-callback.vue?vue&type=script&lang=js&"
import style0 from "./aad-sso-callback.vue?vue&type=style&index=0&id=4cb30552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb30552",
  null
  
)

export default component.exports